import React, { FunctionComponent, useEffect } from 'react';
import { useParams } from 'react-router';
import { useActions } from '../../hooks/useActions';
import { usePhase2FormFields } from '../API/usePhase2FormFields';

import { AddPhase2FormField } from '../features/phase2/AddFormField';
import { Phase2FormFields } from '../features/phase2/FormFields';

type Props = {};
type Params = { orgId: string };

export const Phase2FormManagePage: FunctionComponent<Props> = () => {
  const params: Params = useParams();
  const { phase2FormFields } = usePhase2FormFields(undefined);
  const { setOrgId } = useActions();

  useEffect(() => {
    setOrgId(params.orgId);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <h1>Phase2FormManagePage</h1>
      <Phase2FormFields phase2FormFields={phase2FormFields} />
      <AddPhase2FormField phase2FormFields={phase2FormFields} />
    </div>
  );
};
